import React from 'react'

import './style.scss'

const HeaderTabs = ({ tabList, onChange, selectedIndex }: any) => {
  return (
    <div className="header-tabs-wrapper">
      {tabList.map((tab: any, index: any) => (
        <button
          key={tab.label}
          className={
            selectedIndex === index
              ? 'header-tab-active header-tab'
              : 'header-tab'
          }
          onClick={() => onChange(index)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}

HeaderTabs.defaultProps = {
  tabList: [],
}

export default HeaderTabs
